export default "__VITE_ASSET__CFLdWBGs__"